import Image from 'next/image';

/* eslint-disable-next-line */
type SearchButtonProps = {
  className: string;
  onClick: () => void;
};

export function SearchButton(props: SearchButtonProps) {
  const { className, onClick } = props;

  return (
    <button className={className} onClick={onClick}>
      <Image alt="Search" height={25} src="/icons/search-gray.png" width={25} />
    </button>
  );
}

export default SearchButton;
